import { mode } from '@chakra-ui/theme-tools';
var parts = ['root', 'tablist', 'tab', 'tabpanels', 'tabpanel', 'indicator'];

function baseStyleRoot(props) {
  var {
    orientation
  } = props;
  return {
    display: orientation === 'vertical' ? 'flex' : 'block'
  };
}

function baseStyleTab(props) {
  var {
    isFitted
  } = props;
  return {
    flex: isFitted ? 1 : undefined,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  };
}

function baseStyleTablist(props) {
  var {
    align = 'start',
    orientation
  } = props;
  var alignments = {
    end: 'flex-end',
    center: 'center',
    start: 'flex-start'
  };
  return {
    justifyContent: alignments[align],
    flexDirection: orientation === 'vertical' ? 'column' : 'row'
  };
}

var baseStyleTabpanel = {
  p: 4
};

var baseStyle = props => ({
  root: baseStyleRoot(props),
  tab: baseStyleTab(props),
  tablist: baseStyleTablist(props),
  tabpanel: baseStyleTabpanel
});

var sizes = {
  sm: {
    tab: {
      py: 1,
      px: 4,
      fontSize: 'sm'
    }
  },
  md: {
    tab: {
      fontSize: 'md',
      py: 2,
      px: 4
    }
  },
  lg: {
    tab: {
      fontSize: 'lg',
      py: 3,
      px: 4
    }
  }
};

function variantLine(props) {
  var {
    colorScheme: c,
    orientation
  } = props;
  var isVertical = orientation === 'vertical';
  var borderProp = orientation === 'vertical' ? 'borderStart' : 'borderBottom';
  var marginProp = isVertical ? 'marginStart' : 'marginBottom';
  return {
    tablist: {
      [borderProp]: 'none'
    },
    tab: {
      [borderProp]: '4px solid',
      borderColor: 'transparent',
      [marginProp]: '-2px',
      color: mode('gray.900', 'whiteAlpha.300')(props),
      _selected: {
        color: mode('black', 'whiteAlpha.300')(props),
        fontWeight: 'bold',
        borderColor: mode(c + ".500", c + ".300")(props)
      },
      _active: {
        bg: 'transparent'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      }
    }
  };
}

var variantUnstyled = {};
var variants = {
  line: variantLine,
  unstyled: variantUnstyled
};
var defaultProps = {
  size: 'md',
  variant: 'line',
  colorScheme: 'brand'
};
export default {
  parts,
  baseStyle,
  sizes,
  variants,
  defaultProps
};
//# sourceMappingURL=Tabs.js.map